export default __webpack_public_path__ + "static/media/empty-pie.264659ab.svg";